module.exports = __webpack_public_path__ + "static/media/twin-towers_logo.96328372.svg";